'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN_SUBMIT = exports.LOGIN_SUBMIT = 'LOGIN_SUBMIT';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';

var LOGOUT = exports.LOGOUT = 'LOGOUT';

var REGISTER_SUBMIT = exports.REGISTER_SUBMIT = 'REGISTER_SUBMIT';
var REGISTER_SUCCESS = exports.REGISTER_SUCCESS = 'REGISTER_SUCCESS';
var REGISTER_FAILURE = exports.REGISTER_FAILURE = 'REGISTER_FAILURE';

var REGISTER_INVITE_FETCHED = exports.REGISTER_INVITE_FETCHED = 'REGISTER_INVITE_FETCHED';

var USER_LOCAL_STORAGE_TOKEN_KEY = exports.USER_LOCAL_STORAGE_TOKEN_KEY = 'token';


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/authConstants.js
// module id = 136
// module chunks = 0